<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Dodaj"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="save"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-md-12">
        <w-input :model="$schema.uid" @input="loadDocumentName($schema.uid.$model)" />
      </div>

      <div v-if="documentName" class="form-group col-md-12">
        <p>
          Wybrano dokument: <b>{{ documentName }}</b>
        </p>
      </div>
    </div>
  </w-modal>
</template>

<script>
import { Errors } from '@/enums/errors.enum';
import { mdokDocumentMixin } from '@/mixins/mdokDocument';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/addFromMdok.schema';

const emptyData = () => ({ uid: null });

// @vuese
// Modal dodawania dokumentów z Mdok
// @group Modals
export default {
  mixins: [mdokDocumentMixin, manageMixin(undefined, {}, emptyData)],
  schema,
  methods: {
    // @vuese
    // Waliduje formularz i emituje event do zapisu danych
    save() {
      if (!this.$schema.$validateAll().length) {
        const model = this.prepareModel(this.$schema.$getData());
        this.$emit('save', model);
      } else {
        this.notifyError(Errors.FORM_INCORRECTLY_COMPLETED);
      }
    }
  }
};
</script>
